import React from 'react';
import { INSTRUMENTS } from '../constants/instruments';

export function Watchlist({
  selectedSymbol, setSelectedSymbol, vwapDataBySymbol
}:{
  selectedSymbol: string;
  setSelectedSymbol: (s:string)=>void;
  vwapDataBySymbol: Map<string, Array<{
    timestamp: string;
    vwap: number;
  }>>;
}) {
  return (
    <div style={{ backgroundColor: '#1e293b', padding: 16, borderRadius: 8, border: '1px solid #334155' }}>
      <h3 style={{ margin: '0 0 16px 0', fontSize: 14, fontWeight: 600, color: '#94a3b8' }}>WATCHLIST</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {INSTRUMENTS.map((it) => {
          // Get latest VWAP for this symbol
          const vwapData = vwapDataBySymbol.get(it.secId);
          const latestVwap = vwapData && vwapData.length > 0 
            ? vwapData[vwapData.length - 1]?.vwap 
            : null;
          
          return (
            <div key={it.secId}
              style={{
                display: 'flex', flexDirection: 'column', padding: '8px 12px',
                borderRadius: 6,
                backgroundColor: selectedSymbol === it.secId ? '#334155' : 'transparent',
                cursor: 'pointer',
                border: selectedSymbol === it.secId ? '1px solid #475569' : '1px solid transparent',
                transition: 'all 0.2s'
              }}
              onClick={() => setSelectedSymbol(it.secId)}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 13, fontWeight: 600 }}>{it.label}</span>
                <span style={{ fontSize: 12, fontWeight: 600 }}>
                  {latestVwap != null ? latestVwap.toFixed(2) : '—'}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      <button style={{
        width: '100%',
        marginTop: 12,
        padding: 8,
        backgroundColor: 'transparent',
        color: '#94a3b8',
        border: '1px solid #475569',
        borderRadius: 6,
        cursor: 'pointer',
        fontSize: 12
      }}>
        + Add Symbol
      </button>
    </div>
  );
}
